import { useState, useCallback, useRef } from 'react';
import { agrupamentoService } from '../api/agrupamento';
import type { ProdutoAgrupamento, ProdutoGeral } from '../api/agrupamento';

export const useGrupoProdutos = () => {
  const [produtosGrupo, setProdutosGrupo] = useState<ProdutoAgrupamento[]>([]);
  const [produtosDisponiveis, setProdutosDisponiveis] = useState<ProdutoGeral[]>([]);
  const [carregandoGrupo, setCarregandoGrupo] = useState(false);
  const [carregandoDisponiveis, setCarregandoDisponiveis] = useState(false);
  const loadingGrupoRef = useRef(false);
  const loadingDispRef = useRef(false);

  const carregarProdutosGrupo = useCallback(async (grupoId: number, forceRefresh = false) => {
    if (loadingGrupoRef.current && !forceRefresh) return;
    loadingGrupoRef.current = true;
    setCarregandoGrupo(true);
    try {
      const dados = await agrupamentoService.buscarProdutosDoAgrupamento(grupoId, forceRefresh);
      setProdutosGrupo(dados);
    } catch {
      setProdutosGrupo([]);
    } finally {
      setCarregandoGrupo(false);
      loadingGrupoRef.current = false;
    }
  }, []);

  const buscarDisponiveis = useCallback(async (grupoId: number, termo: string) => {
    if (loadingDispRef.current) return;
    loadingDispRef.current = true;
    setCarregandoDisponiveis(true);
    try {
      const dados = await agrupamentoService.buscarProdutosDisponiveisComBusca(grupoId, termo);
      setProdutosDisponiveis(dados);
    } catch {
      setProdutosDisponiveis([]);
    } finally {
      setCarregandoDisponiveis(false);
      loadingDispRef.current = false;
    }
  }, []);

  const vincularProdutos = useCallback(
    async (grupoId: number, produtos: Array<{ codigo: string; embalagem: string; visivelCat: string }>) => {
      await agrupamentoService.salvarManutencaoLote(
        produtos.map(p => ({
          codigo: p.codigo,
          grupoIdAnterior: null,
          grupoIdNovo: grupoId,
          nomeEmbalagem: p.embalagem || null,
          visivelCat: p.visivelCat,
        }))
      );
      await carregarProdutosGrupo(grupoId, true);
    },
    [carregarProdutosGrupo],
  );

  const removerProduto = useCallback(async (grupoId: number, codigo: string) => {
    await agrupamentoService.removerProdutoDoAgrupamento(grupoId, codigo);
    setProdutosGrupo(prev => prev.filter(p => p.produtoCodigo !== codigo));
  }, []);

  const limpar = useCallback(() => {
    setProdutosGrupo([]);
    setProdutosDisponiveis([]);
  }, []);

  return {
    produtosGrupo,
    produtosDisponiveis,
    carregandoGrupo,
    carregandoDisponiveis,
    carregarProdutosGrupo,
    buscarDisponiveis,
    vincularProdutos,
    removerProduto,
    limpar,
  };
};
